<h3 mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
  {{data.message}}
</div>
<div style="float:right;margin:20px;">
  <button mat-flat-button class="primary-color-icon ok-btn " style="margin:0px 10px;" [mat-dialog-close]="true">Ok</button>
</div>